/**
 * Error Sample
 * 
 *   
ContractFunctionExecutionError: The contract function "openMarketTrade" reverted with the following reason:
TradingCheckerFacet: Position is too small

Contract Call:
  address:   0x4974C0bE9415387771D186A60ba21A669ee58D6D
  function:  openMarketTrade((address pairBase, bool isLong, address tokenIn, uint96 amountIn, uint128 qty, uint128 price, uint128 stopLoss, uint128 takeProfit, uint24 broker))
  args:                     ({"pairBase":"0x693CDC3d252083B342285aD9a0B9f0f74f44F361","isLong":true,"tokenIn":"0x9553dA89510e33BfE65fcD71c1874FF1D6b0dD75","amountIn":"1000000000000000000","qty":"1990235","price":"3879054038636451000000","stopLoss":"0","takeProfit":"3995980000000000000000","broker":1})
  sender:    0x45c6C9Bf6619A95B2F0cB59B8a2EF47a2a738a20

Docs: https://viem.sh/docs/contract/simulateContract
Version: viem@2.17.11
 */
const SC_ERROR_REGEX =
  /(TradingCheckerFacet|VaultFacet|AnyCollateralConfigFacet|LibPriceFacade):(.*?)(?=\n)/; // add once needed  /(TradingCheckerFacet|NeededKeyWords):(.*?)(?=\n)/
const CONTRACT_REVERT_REASON_REGEX =
  /reverted with the following reason:\n(.*?)(?=\n)/;
const GENERIC_ERROR_REGEX = /Error\((.*?)\)/;

export const extractErrorMessage = (e: string): string | null => {
  const revertReasonMatch = e.match(CONTRACT_REVERT_REASON_REGEX);
  if (revertReasonMatch) {
    return revertReasonMatch[1].trim();
  }

  const match = e.match(SC_ERROR_REGEX);
  if (match) {
    return match[2].trim();
  }

  const genericMatch = e.match(GENERIC_ERROR_REGEX);
  
return genericMatch ? genericMatch[1].trim() : null;
};
